/**
 * Perfil de visibilidad de menús/secciones por grupo médico de servicio.
 *
 * MANAGED_MENUS es la lista declarativa de todos los elementos del DOM
 * cuya visibilidad se gestiona por el motor applyServiceVisibility().
 * Cada entrada define:
 *   - selector: selector CSS para encontrar el elemento.
 *   - closest (opcional): si está presente, el elemento a mostrar/ocultar
 *     es el ancestro más cercano que coincida con este selector.
 *   - groups: array de grupos médicos que hacen visible este elemento.
 *     Si la farmacia tiene al menos un servicio activo de alguno de esos
 *     grupos, el elemento se muestra; si no, se oculta.
 *
 * Para añadir un grupo médico nuevo:
 *   1. Insertar el/los servicios en la tabla `services` del backend con el nuevo srv_group.
 *   2. Añadir aquí las entradas de menú/sección que corresponden a ese grupo.
 *
 * Para añadir un menú nuevo a un grupo existente:
 *   1. Añadir la entrada aquí. Sin tocar ningún otro archivo.
 */
export const MANAGED_MENUS = [
    // ── Secciones de navegación ────────────────────────────────────────────────
    // Pacientes y Calendario: solo disponibles para farmacias con servicios respiratorios
    { selector: '[aria-section="section_patients"]', groups: ['respiratorio'] },
    { selector: '[aria-section="section_calendar"]', groups: ['respiratorio'] },

    // ── Perfil del administrador ───────────────────────────────────────────────
    // Firma del titular: exclusiva de servicios respiratorios (requiere firma en formulario SATI/CEPOC)
    { selector: '#btn_admin_signature', closest: '.popup_sep', groups: ['respiratorio'] },

    // Tabs de Perfil exclusivas de servicios respiratorios
    { selector: '#section_profile a[href="profile_drugs"]',    groups: ['respiratorio'] },
    { selector: '#section_profile a[href="profile_calendar"]', groups: ['respiratorio'] },
    { selector: '#section_profile a[href="profile_syncro"]',   groups: ['respiratorio'] },

    // ── Tabs de Consultas (reportes) ───────────────────────────────────────────
    // Grupos visuales Respiratorios / Digestivos
    { selector: '#reports_tabs_group_respiratorios', groups: ['respiratorio'] },
    { selector: '#reports_tabs_group_digestivos',    groups: ['probioticos'] },
    // Tabs de Consultas: Servicios, SATI, IRETIA, Dosing y Equipo → área respiratoria
    { selector: '#section_reports a[href="reports_list"]', groups: ['respiratorio'] },
    { selector: 'a[href="reports_stats"]',        groups: ['respiratorio'] },
    { selector: 'a[href="reports_stats_iretia"]', groups: ['respiratorio'] },
    { selector: 'a[href="reports_dosing"]',       groups: ['respiratorio'] },
    { selector: 'a[href="reports_staff"]',        groups: ['respiratorio'] },

    // ── Material divulgativo — sección de tabaco (solo servicios respiratorios) ──
    { selector: 'a[aria-marketing="marketing_tobacco"]', groups: ['respiratorio'] },

    // ── Tabs de Probióticos ────────────────────────────────────────────────────
    // Tab de probióticos en el perfil de la farmacia
    { selector: '#tab_btn_profile_probiotics', groups: ['probioticos'] },
    // Tabs de historial y estadísticas de equipo en Consultas Probiomentor
    { selector: '#tab_reports_probio_history', groups: ['probioticos'] },
    { selector: '#tab_reports_probio_team',    groups: ['probioticos'] },
]
